import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';

import { colors } from '../../styles';

const styles = css`
  position: fixed;
  top: 0;
  right: 0;
  height: 93px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: all .4s ease-out;
  @media(min-width: 768px) {
    width: 95px;
  }
  @media(min-width: 992px) {
    height: 185px;
  }
  @media(min-width: 1300px) {
    width: 140px;
  }
  &.Button_alt {
    height: 80px;
    width: 80px;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    @media(min-width: 992px) {
      height: 85px;
      width: 85px;
    }
  }

  /* Button Styles */
  button {
    position: relative;
    width: 37px;
    height: 37px;
    display: block;
    border-radius: 0;
    border: none;
    background-color: transparent;
    padding: 0;
  }
  button:focus {
    outline: none;
  }
  input[type="checkbox"] {
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    -webkit-appearance: initial;
    -moz-appearance: initial;
    background-color: transparent;
    border: 0;
  }
  input[type="checkbox"]:focus {
    outline: none;
    border: 0;
    background-color: transparent;
  }
  button span {
    display: block;
    pointer-events: none;
  }
  #ButtonToggler span {
    top: 50%;
    transform: translateY(-50%);
    transition: background-color 350ms ease;
  }
  #ButtonToggler span, #ButtonToggler span::before, #ButtonToggler span::after {
    position: absolute;
    right: -1px;
    width: 100%;
    height: 2px;
    background-color: ${colors.white};
  }
  #ButtonToggler span::before, #ButtonToggler span::after {
    content: "";
    display: block;
    transition: transform 350ms ease;
  }
  #ButtonToggler span::before {
    top: -8px;
    transform-origin: top left;
    width: 38px;
  }
  #ButtonToggler span::after {
    bottom: -8px;
    transform-origin: bottom left;
    width: 38px;
  }
  #ButtonToggler input:checked + span {
    background-color: transparent;
  }
  #ButtonToggler input:checked + span::before {
    transform: translateY(-6px) translateX(4px) rotateZ(45deg);
  }
  #ButtonToggler input:checked + span::after {
    transform: translateY(4px) translateX(4px) rotateZ(-45deg);
  }
  &.HeaderTop_toggler {
    width: 65px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .Button_color {
    &::after, ::before {
      background-color:  ${colors.white} !important;
    }
  }
  .RemovedFromIE {
    @media(min-width: 0\0) {
      display: none !important;
    }
  }
  .Button_color {
    &::after, ::before {
      background-color:  ${colors.white} !important;
    }
  }
  /* Button Styles End*/
`;


function Header({ headerAlt, toggleHeaderLinks }) {
  return (
    <div className={`${styles} ${headerAlt ? '' : 'Button_alt'}`}>
      <div className="HeaderTop_toggler" id="ButtonToggler">
        <button type="button" onClick={toggleHeaderLinks}>
          <input type="checkbox" className="RemovedFromIE" />
          <span className="Button_color" />
        </button>
      </div>
    </div>
  );
}

Header.propTypes = {
  headerAlt: PropTypes.bool.isRequired,
  toggleHeaderLinks: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Button.js